import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import Footer from '../Footer/Footer';

import ResponsiveDrawer from '../Drawer/Drawer';
import { Link, useLocation } from 'react-router-dom';
import { IMGS_URL } from '../../../config';

import IconButton from '@mui/material/IconButton';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
const MainLayout = ({ children, themeMode, toggleTheme }) => {
  const location = useLocation();

  const isDashboard =
    location.pathname === '/dashboard' || location.pathname === '/slider';
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        minHeight: '100vh',
        marginTop: '-10px',
        marginRight: '-10px',
      }}
    >
      {!isDashboard ? (
        <ResponsiveDrawer children={children} />
      ) : (
        <>
          <AppBar sx={{ backgroundColor: '#C09A53', height: '64px' }}>
            <Toolbar variant="regular">
              <Box
                component="img"
                src={`${IMGS_URL}/logo.png`}
                alt="logo"
                sx={{ maxHeight: '100%', maxWidth: '100%' }}
              />
              <Typography
                variant="h6"
                color="inherit"
                component={Link}
                to="/"
                sx={{
                  flexGrow: 1,
                  textAlign: 'center',
                  textDecoration: 'none',
                  color: 'inherit',
                }}
              >
                Home
              </Typography>
            </Toolbar>
          </AppBar>
          {children}
        </>
      )}

      <Footer />
    </Box>
  );
};

export default MainLayout;
